module.exports = __webpack_public_path__ + "img/profile-svg.07d5a75c.svg";